module.exports = {"id":"193116","name":"Maxime Gonalons","rating":"77","photo":"./data/images/photos/2/193116.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaximeGonalons0.json
// module id = 2939
// module chunks = 0